/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from './ActionDrawerBlock.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

export type TypeProps = {
  // eslint-disable-line flow-prefer-exact-object-types
  divider?: boolean,
  flex?: boolean,
  gutters?: boolean,
  heading?: string,
  padding?: boolean,
  display?: string,
  children: React.Node,
};

function ActionDrawerBlock(props: TypeProps): React.Element<*> {
  const {
    children,
    heading,
    gutters,
    flex,
    divider,
    padding,
    display = 'block',
  }: TypeProps = props;

  const hasFlex: string = flex ? styles['has-flex'] : '';
  const hasGutters: string = gutters ? styles['has-gutters'] : '';
  const hasPadding: string = padding ? styles['has-padding'] : '';

  return (
    <React.Fragment>
      <div
        className={`${styles['action-drawer-block']} ${hasFlex} ${hasGutters} ${hasPadding}`}
        style={{ display }}
      >
        {heading && <h3>{heading}</h3>}
        {children}
      </div>
      {divider && <hr />}
    </React.Fragment>
  );
}

export default ActionDrawerBlock;
